import React, { useEffect, useRef } from "react";
import { Animated, View } from "react-native";
import { s } from "../SustainTeamManagementScreen.styles";

interface Props {
  isDark?: boolean;
}

const TeamTableSkeleton: React.FC<Props> = ({ isDark }) => {
  const pulse = useRef(new Animated.Value(0.45)).current;

  useEffect(() => {
    const loop = Animated.loop(
      Animated.sequence([
        Animated.timing(pulse, { toValue: 1,    duration: 700, useNativeDriver: true }),
        Animated.timing(pulse, { toValue: 0.45, duration: 700, useNativeDriver: true }),
      ]),
    );
    loop.start();
    return () => loop.stop();
  }, [pulse]);

  const skeletonColor = isDark ? "#2B2B2B" : "#E4E9F2";

  const bar = (w: number | string, h = 12, radius = 4) => (
    <Animated.View
      style={[
        { opacity: pulse },
        { width: w as any, height: h, borderRadius: radius, backgroundColor: skeletonColor },
      ]}
    />
  );

  return (
    <>
      {Array.from({ length: 7 }).map((_, idx) => (
        <View key={idx} style={[s.row, isDark && { borderBottomColor: "#363636" }, idx % 2 === 0 ? (isDark ? { backgroundColor: "#202020" } : s.rowEven) : (isDark ? { backgroundColor: "#1a1a1a" } : s.rowOdd)]}>
          {/* Name col: circle avatar + text bar */}
          <View style={[s.cell, s.colName]}>
            <Animated.View style={{ opacity: pulse, width: 32, height: 32, borderRadius: 16, backgroundColor: skeletonColor }} />
            {bar("55%")}
          </View>
          {/* Email */}
          <View style={[s.cell, s.colEmail]}>{bar("75%")}</View>
          {/* Role badge */}
          <View style={[s.cell, s.colRole]}>{bar(56, 22, 10)}</View>
          {/* Channels: 3 small circles */}
          <View style={[s.cell, s.colChannels, { justifyContent: "center", flexDirection: "row", gap: 6 }]}>
            {[0, 1, 2].map((i) => (
              <Animated.View key={i} style={{ opacity: pulse, width: 20, height: 20, borderRadius: 10, backgroundColor: skeletonColor }} />
            ))}
          </View>
          {/* Scope */}
          <View style={[s.cell, s.colScope]}>{bar("60%")}</View>
          {/* Status badge */}
          <View style={[s.cell, s.colStatus, { justifyContent: "center" }]}>{bar(68, 22, 10)}</View>
          {/* Actions */}
          <View style={[s.cell, s.colActions, { justifyContent: "flex-end" }]}>{bar(44, 26, 6)}</View>
        </View>
      ))}
    </>
  );
};

export default TeamTableSkeleton;
